<script setup lang="ts">
import { ref } from 'vue';

import KCheckboxField from '@/components/fields/KCheckboxField.vue';
import EmDashPlaceholder from '@/components/placeholders/EmDashPlaceholder.vue';

import tableStyles from '@/styles/table.module.scss';

interface TableDataItem {
  text: string;
  notifications: boolean;
  email: boolean;
  mobile: boolean;
}

const tableData = ref<TableDataItem[]>([
  {
    text: 'A job has been updated',
    notifications: true,
    email: false,
    mobile: false,
  },
  {
    text: 'New ticket has been created',
    notifications: true,
    email: false,
    mobile: false,
  },
  {
    text: 'Someone mentioned me in a message',
    notifications: true,
    email: false,
    mobile: false,
  },
  {
    text: 'A report has been generated',
    notifications: true,
    email: false,
    mobile: false,
  },
]);
</script>

<template>
  <h4>Configure how you would like to be notified</h4>
  <div class="w-min">
    <table :class="[tableStyles.table, $style.profileNotificationsTable]">
      <thead>
        <tr>
          <th class="text-left">Types of notifications</th>
          <th>Notification panel</th>
          <th>Email notification</th>
          <th>Mobile push notification</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dataItem in tableData" :key="dataItem.text">
          <td>
            <EmDashPlaceholder :item="dataItem.text" />
          </td>
          <td>
            <div class="flex justify-center hover:cursor-not-allowed">
              <KCheckboxField
                :model-value="dataItem.notifications"
                :hide-details="true"
                disabled
              />
            </div>
          </td>
          <td>
            <div class="flex justify-center hover:cursor-not-allowed">
              <KCheckboxField
                :model-value="dataItem.email"
                :hide-details="true"
                disabled
              />
            </div>
          </td>
          <td>
            <div class="flex justify-center hover:cursor-not-allowed">
              <KCheckboxField
                :model-value="dataItem.mobile"
                :hide-details="true"
                disabled
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.profileNotificationsTable {
  width: 100%;

  & > thead > tr {
    & > th {
      white-space: nowrap;
    }
  }
}
</style>
